// Time Off is unpriced, so it never gets a pay column, and payroll needs its hours even when
// the priced per-type detail is hidden.
export const getPayrollTypeColumns = (types, showDetails) => {
  return types
    .filter(type => type.isTimeOff || showDetails)
    .flatMap(type => {
      const hours = { timeTypeId: type.timeTypeId, key: `type_${type.timeTypeId}_hours`, text: type.timeTypeName, isAmount: false }
      if (type.isTimeOff) {
        return [hours]
      }
      return [hours, { timeTypeId: type.timeTypeId, key: `type_${type.timeTypeId}_amount`, text: `${type.timeTypeName} Pay`, isAmount: true }]
    })
}

export default getPayrollTypeColumns
